/* Picobellonails collectiepagina: filters, sorteren, laad meer, lades op gsm. */
(function () {
  if (window.pbCollectionReady) return;
  window.pbCollectionReady = true;

  /* ---------- Lades (gsm) ---------- */
  function openDrawer(root, name) {
    const drawer = root.querySelector(`[data-pb-drawer="${name}"]`);
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.classList.add('pb-menu-open');
    drawer.querySelector('button, a, input, select')?.focus({ preventScroll: true });
  }
  function closeDrawers(root) {
    root.querySelectorAll('[data-pb-drawer].is-open').forEach((d) => d.classList.remove('is-open'));
    document.body.classList.remove('pb-menu-open');
  }

  /* ---------- Opnieuw laden van de sectie ---------- */
  let controller;
  async function render(url, { push = true } = {}) {
    const root = getRoot();
    if (!root) return;
    const openDrawer = root.querySelector('[data-pb-drawer].is-open')?.dataset.pbDrawer;
    const sectionId = root.dataset.section;
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);
    controller?.abort();
    controller = new AbortController();
    root.classList.add('is-loading');
    try {
      const res = await fetch(fetchUrl.toString(), { signal: controller.signal });
      const html = await res.text();
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pb-plp]');
      if (!next) throw new Error('Geen collectie gevonden');
      root.innerHTML = next.innerHTML;
      if (openDrawer && window.matchMedia('(max-width: 989px)').matches) {
        root.querySelector(`[data-pb-drawer="${openDrawer}"]`)?.classList.add('is-open');
      } else {
        document.body.classList.remove('pb-menu-open');
      }
      if (push) {
        const clean = new URL(url, window.location.origin);
        clean.searchParams.delete('section_id');
        window.history.pushState({ pbPlp: true }, '', clean.pathname + clean.search);
      }
    } catch (e) {
      if (e.name !== 'AbortError') window.location.href = url;
    } finally {
      root.classList.remove('is-loading');
    }
  }

  function formUrl(form) {
    const data = new FormData(form);
    const params = new URLSearchParams();
    for (const [key, value] of data.entries()) {
      if (value === '') continue;
      const input = form.querySelector(`[name="${CSS.escape(key)}"][data-pb-range]`);
      if (input && Number(value) >= Number(input.max)) continue; // maximum = geen filter
      params.append(key, value);
    }
    return form.getAttribute('action') + (params.toString() ? '?' + params.toString() : '');
  }

  function withSort(sortValue) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortValue);
    url.searchParams.delete('page');
    return url.pathname + url.search;
  }

  /* ---------- Laad meer ---------- */
  async function loadMore(link) {
    const root = getRoot();
    const grid = root.querySelector('[data-pb-grid]');
    link.setAttribute('aria-busy', 'true');
    link.classList.add('is-loading');
    try {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('section_id', root.dataset.section);
      const html = await (await fetch(url.toString())).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('[data-pb-grid] > li').forEach((li) => grid.appendChild(li));
      const newMore = doc.querySelector('[data-pb-more]');
      const oldMore = root.querySelector('[data-pb-more]');
      if (newMore && oldMore) oldMore.replaceWith(newMore);
    } catch (e) {
      window.location.href = link.href;
    }
  }

  /* ---------- Gebeurtenissen ---------- */
  document.addEventListener('click', (event) => {
    const root = getRoot();
    if (!root || !root.contains(event.target)) return;

    const opener = event.target.closest('[data-pb-open-drawer]');
    if (opener) { openDrawer(root, opener.dataset.pbOpenDrawer); return; }
    if (event.target.closest('[data-pb-close-drawer]')) { closeDrawers(root); return; }

    const sortBtn = event.target.closest('[data-pb-sort]');
    if (sortBtn) { closeDrawers(root); render(withSort(sortBtn.dataset.pbSort)); return; }

    const more = event.target.closest('[data-pb-load-more]');
    if (more) { event.preventDefault(); loadMore(more); return; }

    const link = event.target.closest('a[data-pb-link]');
    if (link && !event.metaKey && !event.ctrlKey) { event.preventDefault(); render(link.href); }
  });

  document.addEventListener('change', (event) => {
    const root = getRoot();
    if (!root || !root.contains(event.target)) return;
    const form = event.target.closest('[data-pb-filters]');
    if (form) { render(formUrl(form)); return; }
    if (event.target.matches('[data-pb-sort-select]')) render(withSort(event.target.value));
  });

  document.addEventListener('input', (event) => {
    const root = getRoot();
    if (!root || !root.contains(event.target)) return;
    if (event.target.matches('[data-pb-range]')) {
      const out = event.target.closest('.pb-filter__range').querySelector('[data-pb-range-out]');
      if (out) out.textContent = event.target.value;
    }
  });

  document.addEventListener('keydown', (event) => {
    const root = getRoot();
    if (event.key === 'Escape' && root) closeDrawers(root);
  });

  window.addEventListener('popstate', () => {
    if (getRoot()) render(window.location.href, { push: false });
  });

})();
